import { Check, Github, Languages } from 'lucide-react';

// GitHub website targets (e.g. xchannels.ai) for the blog schedule modal.
export const GithubTargetButtons = ({ targets, value, onChange, lang }) => (
  <>
    {(targets || []).map((t) => {
      const key = `github:${t.id}`;
      const active = value === key;
      return (
        <button
          key={key}
          type="button"
          disabled={!!t.reason}
          title={t.reason || ''}
          onClick={() => onChange(key)}
          className={`flex items-center gap-2 px-3 py-2 rounded border transition-colors text-sm disabled:opacity-40 disabled:cursor-not-allowed ${
            active ? 'bg-[#00D9C8]/10 border-[#00D9C8] text-white' : 'bg-[#0A1628] border-transparent text-[#A0AEC0] hover:border-[#5A6C7D]'
          }`}
          data-testid={`schedule-target-github-${t.id}`}
        >
          <Github className="w-4 h-4 text-white" />
          {t.name}
          {t.is_staging && (
            <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-amber-500/20 text-amber-300" data-testid={`schedule-target-github-${t.id}-staging`}>
              Staging
            </span>
          )}
          {t.article?.status === 'published' && (
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-green-500/20 text-green-300">{lang === 'de' ? 'Update' : 'Update'}</span>
          )}
          {active && <Check className="w-3.5 h-3.5 ml-1" />}
        </button>
      );
    })}
  </>
);

export const GithubTargetDetails = ({ target, translationOf, onTranslationChange, lang }) => {
  if (!target) return null;
  const de = lang === 'de';
  return (
    <div className="mt-2 space-y-2" data-testid="github-target-details">
      {target.reason && <p className="text-xs text-[#F97066]" data-testid="github-target-reason">{target.reason}</p>}
      <label className="text-xs text-[#A0AEC0] flex items-center gap-1.5">
        <Languages className="w-3.5 h-3.5" />
        {de ? 'Übersetzung von (optional)' : 'Translation of (optional)'}
      </label>
      <select
        value={translationOf || ''}
        onChange={(e) => onTranslationChange(e.target.value)}
        className="w-full bg-[#0A1628] border border-[#1A2B42] rounded px-2 py-1.5 text-sm text-white"
        data-testid="github-translation-select"
        x-excluded="true"
      >
        <option value="" label={de ? 'Keine – eigenständiger Artikel' : 'None – standalone article'} />
        {(target.translation_candidates || []).map((c) => (
          <option key={c.id} value={c.id} label={`[${(c.language || '').toUpperCase()}] ${c.title}`} />
        ))}
      </select>
      <p className="text-[11px] text-[#5A6C7D]">
        {de
          ? `Sprache dieses Artikels: ${(target.language || '–').toUpperCase()} · Ziel-Branch: ${target.branch}. Es wird nichts automatisch übersetzt.`
          : `Article language: ${(target.language || '–').toUpperCase()} · Target branch: ${target.branch}. Nothing is translated automatically.`}
      </p>
    </div>
  );
};
